export const defaultInputValidationPaneSubtitleStyles = {
  color: "#262626",
  fontFamily: "'Segoe UI', Arial, sans-serif",
  fontSize: "14px",
  lineHeight: "16px",
  marginBottom: "10px"
};